<template>
    <div :class="classList" v-on="$listeners">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "VColumn",
    props: {
        xs: [String, Number],
        sm: [String, Number],
        md: [String, Number],
        lg: [String, Number],
        cols: [String, Number]
    },
    computed: {
        classList() {
            let list = ["col"];

            if (this.cols) {
                list.push(`col-${this.cols}`);
            }

            ["xs", "sm", "md", "lg"].forEach(size => {
                if (this[size]) {
                    list.push(`col-${size}-${this[size]}`);
                }
            });

            return list;
        }
    }
};
</script>